<modal-popup
  [flexible]="true"
  [focusOnOpen]="true"
  [isOpen]="true"
  (onClose)="close()"
  [title]="'translate.mng.createReport' | translate"
>
  <div class="container">
    <div>
      <input-wrap
        label="{{ 'translate.general.reportName' | translate }}"
        cssClass="l-cell-spread"
        
      >
        <input type="text" readonly [(ngModel)]="report.reportName" class="t-input" />
      </input-wrap>
      <!-- report definition-->
       <input-wrap
        label="{{ 'translate.general.reportDefinition' | translate }}"
        cssClass="l-cell-spread"
        [required]="true"
      >
        <p-select
        [options]="reportDefinitions"
        optionLabel="name"
        (onChange)="selectReportDefinition($event)" 
        placeholder="Select item">
        </p-select>
      </input-wrap>
       <input-wrap
        label="{{ 'translate.general.startDate' | translate }}"
        cssClass="l-cell-spread"
        [required]="true"
      >
          <input type="date" #startDate (change)="onDateChange($event, true)" class="t-input" />
      </input-wrap>
       <input-wrap
        label="{{ 'translate.general.endDate' | translate }}"
        cssClass="l-cell-spread"
        [required]="true"
      >
        <input type="date" #endDate (change)="onDateChange($event, false)" class="t-input" />

      </input-wrap>
        <button
          [disabled]="!allowSubmit() || saving"
          (click)="updateReport()"
          class="t-button-outline"
        >
          {{ "translate.general.save" | translate }}
        </button>
    </div>
  
  </div>